export default {
    CHANGE_ACCOUNT_AVATAR: "CHANGE_ACCOUNT_AVATAR",
    CHANGE_ACCOUNT_AVATAR_DONE: "CHANGE_ACCOUNT_AVATAR_DONE",
};